import React from 'react';

/**
 * PageHeader — single source of truth for pillar/feature page headers.
 *
 * Pattern:
 *   <icon> <SMALL UPPERCASE PILLAR TAG (colored)>
 *   Mixed-case page title (large, tracking-tight)
 *   Subtitle in zinc-400
 *   [optional right-side actions slot]
 *
 * Pillar colors:
 *   Movement   #CCFF00 (lime)
 *   Recovery   #22d3ee (cyan)
 *   Mental     #a855f7 (purple)
 *   Nutrition  #fb923c (orange)
 *   Cycle      #ec4899 (pink)
 */
const PageHeader = ({
  tag,
  tagColor = '#CCFF00',
  icon: Icon,
  title,
  subtitle,
  actions,
  testIdPrefix,
}) => {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap" data-testid={testIdPrefix ? `${testIdPrefix}-header` : undefined}>
      <div className="min-w-0 flex-1">
        {(tag || Icon) && (
          <div className="flex items-center gap-2 mb-2">
            {Icon && <Icon className="w-4 h-4" style={{ color: tagColor }} />}
            {tag && (
              <span
                className="text-[10px] uppercase tracking-[0.2em] font-secondary font-bold"
                style={{ color: tagColor }}
                data-testid={testIdPrefix ? `${testIdPrefix}-tag` : undefined}
              >
                {tag}
              </span>
            )}
          </div>
        )}
        <h1
          className="text-3xl md:text-4xl font-secondary font-bold tracking-tight"
          data-testid={testIdPrefix ? `${testIdPrefix}-title` : undefined}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-zinc-400 mt-1 text-sm md:text-base">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
};

export default PageHeader;
